import { IsInt, IsNumber, IsOptional, Min } from 'class-validator';
import { Type } from 'class-transformer';

export class ConciliarDto {
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  toleranciaDias?: number;

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0)
  toleranciaMonto?: number;
}
